import React                         from 'react';
import PropTypes                     from 'prop-types';
import {buildVideoUrls, VideoPlayer} from '../../Gallery/VideoPlayer';

class SinglePostVideo extends React.Component {

	constructor(props) {
		super(props);

		this.state        = {
			open: props.autoPlay,
		};
		this.contentBox   = null;
		this.imageWrapper = null;
		this.media        = null;

		this.assignContent = this._assignContentRefHandler.bind(this);
		this.openVideo     = this.openVideoHandler.bind(this);
		this.closeVideo    = this.closeVideoHandler.bind(this);
	}

	/**
	 * @link https://reactjs.org/docs/refs-and-the-dom.html
	 * @param {HTMLElement} videoWrapper
	 * @private
	 */
	_assignContentRefHandler(videoWrapper) {
		if (null === videoWrapper || !videoWrapper.parentNode) {
			return;
		}

		const row = videoWrapper.parentNode.parentNode;

		// top level video/image wrapper
		this.imageWrapper = row.querySelector('.magazine-blog-post--single__image-wrapper');

		// article content box
		this.contentBox = row.querySelector('.magazine-blog-post--single__box');

		// adjust DOM if auto-play
		if (this.props.autoPlay) {
			this.contentBox.classList.add('-no-margin');
			this.imageWrapper.classList.add('-is-maximized');
		}
	}

	/**
	 * @param {Event} e
	 */
	openVideoHandler(e) {
		e.preventDefault();

		this.contentBox.classList.add('-no-margin');
		this.imageWrapper.classList.add('-is-maximized');

		this.setState({
			open: true,
		});
	}

	/**
	 * @param {Event} e
	 */
	closeVideoHandler(e) {
		e.preventDefault();

		this.contentBox.classList.remove('-no-margin');
		this.imageWrapper.classList.remove('-is-maximized');

		this.setState({
			open: false,
		});
	}

	render() {
		if (!this.state.open) {
			return (
				<div className="magazine-blog-post--single__video-wrapper" ref={this.assignContent} onClick={this.openVideo}>
					<img src={this.props.preview} className="magazine-blog-post--single__image" />
					<i className="icon -icon-play-rounded-line"></i>
				</div>
			);
		}

		const video = {
			pinned:             false,
			videoUrls:          buildVideoUrls(this.props.video),
			previewPictureUrls: [{pictureUrl: this.props.preview}],
			albumId:            null,
			albumTitle:         null,
			titleUrl:           null,
			actorName:          null,
			videoDuration:      null,
			actorUrl:           null,
		};

		return (
			<div className="magazine-blog-post--single__video-wrapper" ref={this.assignContent}>
				<div className="js-tv-media-single-videoplayer">
					<VideoPlayer initialVideos={[video]}
					             initShowModal={false}
					             autoplay={true}
					             showDownload={false}
					             showLike={false}
					             showDislike={false}
					             videoTimestamp={0}
					             instanceId={this.props.video}
					             videoId=''
					/>
				</div>
				<i className="icon -icon-close-line" onClick={this.closeVideo}></i>
			</div>
		);
	}
}

SinglePostVideo.propTypes = {
	video:    PropTypes.string,
	preview:  PropTypes.string,
	autoPlay: PropTypes.bool,
};

SinglePostVideo.defaultProps = {
	autoPlay: false,
};

SinglePostVideo.VIDEO_PREVIEW_HEIGHT = 700;

export default SinglePostVideo;
